import React from 'react';
import { Minus, Plus, RefreshCcw } from 'react-feather';

const ControlButtons = ({ onZoomIn, onZoomOut, onReset, onMove }) => {
  return (
    <div className="control-buttons">
      {/* <button onClick={() => onMove("up")} className="control-button">
        <i class="fas fa-arrow-up"></i>
      </button>
      <button onClick={() => onMove("down")} className="control-button">
        <i class="fas fa-arrow-down"></i>
      </button>
      <button onClick={() => onMove("left")} className="control-button">
        <i class="fas fa-arrow-left"></i>
      </button>
      <button onClick={() => onMove("right")} className="control-button">
        <i class="fas fa-arrow-right"></i>
      </button> */}
      {/* <button onClick={onZoomIn} className="control-button">
        <i class="fas fa-plus"></i>
      </button>
      <button onClick={onZoomOut} className="control-button">
        <i class="fas fa-minus"></i>
      </button>
      <button onClick={onReset} className="control-button">
        <i class="fas fa-undo-alt"></i>
      </button> */}
      <div
        style={{
          backgroundColor: '#c4871b',
          borderRadius: '10px',
          padding: '5px',
        }}
        onClick={onZoomOut}
      >
        <Minus color="white" size={20} className="m-0" />
      </div>
      <div
        style={{
          backgroundColor: '#c4871b',
          borderRadius: '10px',
          padding: '5px',
        }}
        onClick={onZoomIn}
      >
        <Plus color="white" size={20} className="m-0" />
      </div>
      <div
        style={{
          backgroundColor: '#c4871b',
          borderRadius: '10px',
          padding: '5px',
        }}
        onClick={onReset}
      >
        <RefreshCcw color="white" size={20} className="m-0" />
      </div>
    </div>
  );
};

export default ControlButtons;
